var map = {
	"./child-branch-end.svg": 55544,
	"./child-branch-middle.svg": 44146,
	"./logo.svg": 3914,
	"./onboarding-logo-light.svg": 31535,
	"./small-logo-dark.svg": 37333,
	"./small-logo-light.svg": 22099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17106;